import React, { Component } from 'react'
import PropTypes from 'prop-types'

class NoClientsSelected extends Component {
	render() {
		return (
			<div className='container-fluid'>
				<div className='row'>
					<div
						className='col-md-12 center'
						style={{
							minHeight: 'calc(100vh - 90px)',
						}}
					>
						<h1>No client selected</h1>
					</div>
				</div>
			</div>
		)
	}
}

NoClientsSelected.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default NoClientsSelected
